import { withoutCode } from "#features/conversations/utils/markdownCode.ts";
import type { Skill, SkillTemplateSelection } from "#types/types.ts";

// A `/{slug}` counts as a slash-command invocation only when it sits at a word boundary
// (start of message or preceded by whitespace) and matches a known skill slug — otherwise
// the same characters can appear in URLs, file paths, or plain writing without meaning
// anything to the assistant. A "/slug" inside code is code, as the composer shows it, not a command.
// Each skill found takes its default template.
export const parseSelectedSkills = (content: string, skills: Skill[]): Record<string, SkillTemplateSelection> | undefined => {
    if (skills.length === 0) {
        return undefined;
    }

    const knownSlugs = new Set(skills.map(skill => skill.slug));
    const found: Record<string, SkillTemplateSelection> = {};
    const pattern = /(?:^|\s)\/(\S+)/g;

    let match: RegExpExecArray | null;
    const commands = withoutCode(content);
    while ((match = pattern.exec(commands)) !== null) {
        const candidate = match[1];
        if (knownSlugs.has(candidate)) {
            found[candidate] = {};
        }
    }

    return Object.keys(found).length > 0 ? found : undefined;
};
